// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"32":"af4bdf2d","43":"098de408","79":"c39f7aa2","178":"702703eb","284":"b26b6eb1","460":"7ad4c615","597":"d71015be","679":"58ca4ff2","728":"08ca35d0","950":"8a9ccaa9"}[chunkId] + ".chunk.js";
};